import type { SessionState } from '@stores/session/session-ngrx.reducer';

import { createSelector } from '@ngrx/store';
import { sessionKey } from '@stores/session/session-ngrx.reducer';
import { toIdentityCard } from '@wizbii/utils/models';

const selectSessionState = (state: any): SessionState => state[sessionKey];

export const isInitialized = createSelector(selectSessionState, (state) => {
  return !!state.user && !!state.identityCard;
});
export const user = createSelector(selectSessionState, (state) => state.user);
export const identityCard = createSelector(selectSessionState, (state) => toIdentityCard(state.identityCard));
